<div class="form-field" [formGroup]="group" [ngStyle]="field.containerStyles">
  <mat-slide-toggle [gioEnableControl]="isEnabledFn(field.name, field.id)" [ngStyle]="field.slideStyles"
    [required]="field.required" [formControlName]="field.name"  [color]="field.color">{{field.label}}</mat-slide-toggle>
</div>
